// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KJxK","left":"styles_left__2gGtz","desktopActions":"styles_desktopActions__3rB4p","title":"styles_title__3Do4S"};